import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateTimetableRequest, IUpdateTimetableResponse } from './types';

export const updateTimetable = async (
  timetableId: string,
  requestBody: IUpdateTimetableRequest,
): Promise<IUpdateTimetableResponse> => {
  const response = await fetch(`${API_URL}/timetables/${timetableId}`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Something went wrong whilst updating the timetable.');
  }

  return response.json();
};
